/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateCustomPortionRequest } from '../model';
// @ts-ignore
import { RateMealSelectionRequest } from '../model';
// @ts-ignore
import { UpdateSelectionIngredientsRequest } from '../model';
// @ts-ignore
import { UpdateSelectionMealRequest } from '../model';
// @ts-ignore
import { UserMenuSelectionResponse } from '../model';
/**
 * SelectionControllerApi - axios parameter creator
 * @export
 */
export const SelectionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} selectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCustomPortionRequest: async (selectionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('cancelCustomPortionRequest', 'selectionId', selectionId)
            const localVarPath = `/selections/{selectionId}/custom-portion`
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} selectionId 
         * @param {CreateCustomPortionRequest} createCustomPortionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomPortionRequest: async (selectionId: string, createCustomPortionRequest: CreateCustomPortionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('createCustomPortionRequest', 'selectionId', selectionId)
            // verify required parameter 'createCustomPortionRequest' is not null or undefined
            assertParamExists('createCustomPortionRequest', 'createCustomPortionRequest', createCustomPortionRequest)
            const localVarPath = `/selections/{selectionId}/custom-portion`
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomPortionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelectionsByDate: async (date: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getSelectionsByDate', 'date', date)
            const localVarPath = `/selections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} selectionId 
         * @param {RateMealSelectionRequest} rateMealSelectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateSelection: async (selectionId: string, rateMealSelectionRequest: RateMealSelectionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('rateSelection', 'selectionId', selectionId)
            // verify required parameter 'rateMealSelectionRequest' is not null or undefined
            assertParamExists('rateSelection', 'rateMealSelectionRequest', rateMealSelectionRequest)
            const localVarPath = `/selections/{selectionId}/rate`
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rateMealSelectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} selectionId 
         * @param {UpdateSelectionMealRequest} updateSelectionMealRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swapSelectionMeal: async (selectionId: string, updateSelectionMealRequest: UpdateSelectionMealRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('swapSelectionMeal', 'selectionId', selectionId)
            // verify required parameter 'updateSelectionMealRequest' is not null or undefined
            assertParamExists('swapSelectionMeal', 'updateSelectionMealRequest', updateSelectionMealRequest)
            const localVarPath = `/selections/{selectionId}/meal`
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSelectionMealRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} selectionId 
         * @param {UpdateSelectionIngredientsRequest} updateSelectionIngredientsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSelectionIngredients: async (selectionId: string, updateSelectionIngredientsRequest: UpdateSelectionIngredientsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('updateSelectionIngredients', 'selectionId', selectionId)
            // verify required parameter 'updateSelectionIngredientsRequest' is not null or undefined
            assertParamExists('updateSelectionIngredients', 'updateSelectionIngredientsRequest', updateSelectionIngredientsRequest)
            const localVarPath = `/selections/{selectionId}/ingredients`
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSelectionIngredientsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SelectionControllerApi - functional programming interface
 * @export
 */
export const SelectionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SelectionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} selectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelCustomPortionRequest(selectionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelCustomPortionRequest(selectionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} selectionId 
         * @param {CreateCustomPortionRequest} createCustomPortionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomPortionRequest(selectionId: string, createCustomPortionRequest: CreateCustomPortionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomPortionRequest(selectionId, createCustomPortionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSelectionsByDate(date: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserMenuSelectionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSelectionsByDate(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} selectionId 
         * @param {RateMealSelectionRequest} rateMealSelectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rateSelection(selectionId: string, rateMealSelectionRequest: RateMealSelectionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rateSelection(selectionId, rateMealSelectionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} selectionId 
         * @param {UpdateSelectionMealRequest} updateSelectionMealRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async swapSelectionMeal(selectionId: string, updateSelectionMealRequest: UpdateSelectionMealRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.swapSelectionMeal(selectionId, updateSelectionMealRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} selectionId 
         * @param {UpdateSelectionIngredientsRequest} updateSelectionIngredientsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSelectionIngredients(selectionId: string, updateSelectionIngredientsRequest: UpdateSelectionIngredientsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMenuSelectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSelectionIngredients(selectionId, updateSelectionIngredientsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SelectionControllerApi - factory interface
 * @export
 */
export const SelectionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SelectionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} selectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCustomPortionRequest(selectionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.cancelCustomPortionRequest(selectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} selectionId 
         * @param {CreateCustomPortionRequest} createCustomPortionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomPortionRequest(selectionId: string, createCustomPortionRequest: CreateCustomPortionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createCustomPortionRequest(selectionId, createCustomPortionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelectionsByDate(date: string, options?: any): AxiosPromise<Array<UserMenuSelectionResponse>> {
            return localVarFp.getSelectionsByDate(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} selectionId 
         * @param {RateMealSelectionRequest} rateMealSelectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateSelection(selectionId: string, rateMealSelectionRequest: RateMealSelectionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.rateSelection(selectionId, rateMealSelectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} selectionId 
         * @param {UpdateSelectionMealRequest} updateSelectionMealRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swapSelectionMeal(selectionId: string, updateSelectionMealRequest: UpdateSelectionMealRequest, options?: any): AxiosPromise<void> {
            return localVarFp.swapSelectionMeal(selectionId, updateSelectionMealRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} selectionId 
         * @param {UpdateSelectionIngredientsRequest} updateSelectionIngredientsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSelectionIngredients(selectionId: string, updateSelectionIngredientsRequest: UpdateSelectionIngredientsRequest, options?: any): AxiosPromise<UserMenuSelectionResponse> {
            return localVarFp.updateSelectionIngredients(selectionId, updateSelectionIngredientsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SelectionControllerApi - object-oriented interface
 * @export
 * @class SelectionControllerApi
 * @extends {BaseAPI}
 */
export class SelectionControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} selectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SelectionControllerApi
     */
    public cancelCustomPortionRequest(selectionId: string, options?: AxiosRequestConfig) {
        return SelectionControllerApiFp(this.configuration).cancelCustomPortionRequest(selectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} selectionId 
     * @param {CreateCustomPortionRequest} createCustomPortionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SelectionControllerApi
     */
    public createCustomPortionRequest(selectionId: string, createCustomPortionRequest: CreateCustomPortionRequest, options?: AxiosRequestConfig) {
        return SelectionControllerApiFp(this.configuration).createCustomPortionRequest(selectionId, createCustomPortionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SelectionControllerApi
     */
    public getSelectionsByDate(date: string, options?: AxiosRequestConfig) {
        return SelectionControllerApiFp(this.configuration).getSelectionsByDate(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} selectionId 
     * @param {RateMealSelectionRequest} rateMealSelectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SelectionControllerApi
     */
    public rateSelection(selectionId: string, rateMealSelectionRequest: RateMealSelectionRequest, options?: AxiosRequestConfig) {
        return SelectionControllerApiFp(this.configuration).rateSelection(selectionId, rateMealSelectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} selectionId 
     * @param {UpdateSelectionMealRequest} updateSelectionMealRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SelectionControllerApi
     */
    public swapSelectionMeal(selectionId: string, updateSelectionMealRequest: UpdateSelectionMealRequest, options?: AxiosRequestConfig) {
        return SelectionControllerApiFp(this.configuration).swapSelectionMeal(selectionId, updateSelectionMealRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} selectionId 
     * @param {UpdateSelectionIngredientsRequest} updateSelectionIngredientsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SelectionControllerApi
     */
    public updateSelectionIngredients(selectionId: string, updateSelectionIngredientsRequest: UpdateSelectionIngredientsRequest, options?: AxiosRequestConfig) {
        return SelectionControllerApiFp(this.configuration).updateSelectionIngredients(selectionId, updateSelectionIngredientsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

